import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface QuestionnaireResponseState {
  questionnaireResponses: Record<string, QuestionnaireResponse | undefined>;
}

const initialState: QuestionnaireResponseState = {
  questionnaireResponses: {},
};

export const questionnaireResponseSlice = createSlice({
  name: "questionnaireResponses",
  initialState,
  reducers: {
    setGynecologicalEncounterQuestionnaireResponses: (
      state,
      action: PayloadAction<Record<string, QuestionnaireResponse | undefined>>,
    ) => {
      state.questionnaireResponses = action.payload;
    },
    updateGynecologicalEncounterQuestionnaireResponse: (
      state,
      action: PayloadAction<{
        questionnaireName: string;
        questionnaireResponse: QuestionnaireResponse;
      }>,
    ) => {
      state.questionnaireResponses[action.payload.questionnaireName] =
        action.payload.questionnaireResponse;
    },
  },
});

export const {
  setGynecologicalEncounterQuestionnaireResponses,
  updateGynecologicalEncounterQuestionnaireResponse,
} = questionnaireResponseSlice.actions;

// Selectors
export const selectAllGynecologicalEncounterQuestionnaireResponses = (state: RootState) =>
  state.gynecologicalEncounter.questionnaireResponses;

export const selectGynecologicalEncounterQuestionnaireResponseByQuestionnaireName = (
  state: RootState,
  questionnaireName: string,
) => state.gynecologicalEncounter.questionnaireResponses[questionnaireName];

export default questionnaireResponseSlice.reducer;
